import classNames from "classnames";
import { Immutable } from "immer";
import React from "react";
import SVG from "react-inlinesvg";

import iconCaretDown from "../../assets/svg/caret-down.svg";
import { IMenuCategoryLink } from "../../utils/menu.interface";

type IProps = Immutable<{
    isMobile: boolean;
    modalIsOpen: boolean;
    linkObject: IMenuCategoryLink;
}> & {
    openModal: (event: React.MouseEvent<HTMLElement>) => void;
};

export const CategoryLink = ({
    isMobile,
    modalIsOpen,
    linkObject,
    openModal,
}: IProps): React.ReactNode => {
    if (isMobile) {
        return (
            <div
                key={linkObject.value.title}
                className="main-dropdown-menu__mobile main-dropdown-menu__mobile-link"
            >
                {linkObject.value.title}
            </div>
        );
    }

    const categoryLinkClass = classNames({
        "site-nav__main-menu-item": true,
        [`site-nav__main-menu-item--${linkObject.value.title
            .replace(/\s+/g, "-")
            .toLowerCase()}`]: true,
        "site-nav__main-menu-item--hover-state": true,
        "site-nav__main-menu-item--hover-category-link": modalIsOpen,
    });

    return (
        <span key={linkObject.value.title}>
            <button
                onClick={(e) => {
                    openModal(e);
                }}
                className={categoryLinkClass}
            >
                {linkObject.value.title}
                <SVG
                    src={iconCaretDown}
                    className="site-nav__shop-icon"
                    aria-hidden="true"
                />
            </button>
        </span>
    );
};
